<!-- Simple layout container with a fixed header and an optional fixed footer. The content is scrollable -->
<!-- The layout container itself fills the containing outer div -->
<template>
  <div class="FillVerticalLayout">
    <div class="header">
      <div class="d-flex flex-wrap flex-row py-2" style="flex: 1">
        <slot name="header-row-1-left" />
      </div>
      <div class="header-right-slot">
        <slot name="header-row-1-right" />
      </div>
    </div>

    <div class="header" v-if="$slots['header-row-2-left'] || $slots['header-row-2-right']">
      <div class="d-flex flex-wrap flex-row py-2" style="flex: 1">
        <slot name="header-row-2-left" />
      </div>
      <div class="header-right-slot">
        <slot name="header-row-2-right" />
      </div>
    </div>

    <div class="content">
      <slot name="content"></slot>
    </div>

    <div class="footer" v-if="$slots['footer']">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FillVerticalLayout',
  props: {
    headerBg: String,
  },
};
</script>

<style scoped>
.FillVerticalLayout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: inherit;
  overflow: hidden;
  padding: 0;
  border-right: 1px solid #d0d0d0;
}

.theme--dark .FillVerticalLayout {
  border-right: 1px solid #404040;
}

.header,
.footer {
  display: flex;
  flex-wrap: wrap;
  justify-items: center;
  width: 100%;

  overflow: hidden;
}

.header {
  border-bottom: 1px solid #d0d0d0;
}

.theme--dark .header {
  border-bottom: 2px solid #000;
}

.header-right-slot {
  justify-content: center;
  align-items: flex-end;
  display: flex;
  width: 40px;
  height: 100%;
  position: relative;
  padding: 8px 0;
  margin-right: 4px;
}

.content {
  width: 100%;
  display: flex;
  flex: 1;
  overflow-y: scroll;
}

.content::-webkit-scrollbar,
::-webkit-scrollbar {
  display: none;
}

* {
  scrollbar-width: none;
  /* Firefox */
}

.content {
  -ms-overflow-style: none !important;
  /* IE 11 */
  scrollbar-width: none !important;
  /* Firefox 64 */
}
</style>
